import styled from '@emotion/styled';
import { Chip, Typography } from '@material-ui/core';
import { ClassAttributes, createElement, ReactNode } from 'react';

import theme from '../../../../theme';

interface Props {
  status: ReactNode;
  className?: string;
}

const StatusLabel = ({ status }: ClassAttributes<HTMLElement> & Props) => {
  return (
    <Typography component="div">
      <Status label={status} />
    </Typography>
  );
};

const Status = styled(Chip)({
  background: theme.palette.info.main,
  color: theme.palette.common.white,
  fontWeight: 'bold',
});

export default StatusLabel;
